import { Component, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'

import { Observable, Subject } from 'rxjs'

import { User } from '../../../@core/interfaces/common/users'

import { CommonModule, NgIf } from '@angular/common'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroComputerDesktop } from '@ng-icons/heroicons/outline'
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons'
import { ExcelExportData, KENDO_EXCELEXPORT } from '@progress/kendo-angular-excel-export'
import { ColumnComponent, DataBindingDirective, ExcelCommandDirective, ExcelComponent, GridDataResult, GridToolbarFocusableDirective, KENDO_GRID, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { SortDescriptor, State, process } from '@progress/kendo-data-query'
import { UserService } from '../../../@theme/services/user.service'
import { EdituserComponent } from '../editusers/edituser.component'

export enum UserFormMode {
  VIEW = 'View',
  EDIT = 'Edit',
  ADD = 'Add',
  EDIT_SELF = 'EditSelf',
}

@Component({
    selector: 'gd--user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    imports: [
        CommonModule,
        NgIf,
        KENDO_BUTTON,
        KENDO_GRID,
        KENDO_EXCELEXPORT,
        DataBindingDirective,
        ToolbarTemplateDirective,
        ExcelCommandDirective,
        GridToolbarFocusableDirective,
        ColumnComponent,
        ExcelComponent,
        EdituserComponent,
        NgIcon
    ],
    providers: [
        provideIcons({ heroComputerDesktop })
    ]
})
export class UserComponent implements OnInit, OnDestroy {
  userSelected: any = []
  userlist: any[] = []
  rolelist: any[] = []
  emailTypelist: any[] = []
  productTypelist: any[] = []
  userForm: UntypedFormGroup
  public Userheadername = 'User List'
  getUserId: string
  public bindingType = 'array'
  public view: Observable<GridDataResult>
  public gridData: any

  public state: State = {
    skip: 0,
    take: 5,
  }
  public sort: SortDescriptor[] = [{ field: 'userName', dir: 'asc' }]
  protected readonly unsubscribe$ = new Subject<void>()
  public mode = false
  constructor(private fb: UntypedFormBuilder, private ur: UserService) {
    this.allData = this.allData.bind(this)
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort
  }

  /* Export the whole user list, not just the page on screen. Filters are
     deliberately not applied - the export is always the full list. */
  public allData(): ExcelExportData {
    return {
      data: process(this.userlist, { sort: this.sort }).data,
    }
  }
  ngOnInit(): void {
    this.GetListTypes()
    this.loadUserData()
  }
  async onSelect(rowSelected: any) {
    this.mode = true
    this.Userheadername = 'Edit User'
    this.userSelected = rowSelected.selectedRows[0].dataItem
  }
  /*   initUserForm() {
    this.userForm = this.fb.group({
      id: this.fb.control(''),
      role: this.fb.control(''),
      firstName: this.fb.control('', [Validators.minLength(3), Validators.maxLength(20)]),
      lastName: this.fb.control('', [Validators.minLength(3), Validators.maxLength(20)]),
      login: this.fb.control('', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]),
      email: this.fb.control('', [
        Validators.required,
        Validators.pattern(EMAIL_PATTERN),
      ]),
      username: this.fb.control(''),
      address: this.fb.group({
        street: this.fb.control(''),
        city: this.fb.control(''),
        zipCode: this.fb.control(''),
      }),
    });
  } */
  GetListTypes() {
    this.ur.getRoleList().subscribe((response) => {
      this.rolelist = response
    })
    this.ur.getEmailTypeList().subscribe((response) => {
      this.emailTypelist = response
    })
    this.ur.getproductTypeList().subscribe((response) => {
      this.productTypelist = response
    })
  }
  loadUserData() {
    this.ur.getUserList().subscribe((response) => {
      this.userlist = response
    })
  }
  convertToUser(value: any): User {
    const user: User = value
    return user
  }
  save() {
    this.convertToUser(this.userForm.value)
  }
  back() {
    this.mode = false
    this.loadUserData()
    this.Userheadername = 'User List'
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }
}
